import type { EditorConfig, Wikitag } from './types';
import type { Extensions } from '@tiptap/core';
import {
   CustomCode,
   CustomHeading,
   EditableLink,
   // MediaManager,
   CustomUnderline,
   CustomMention,
   CustomBlockquote,
   CustomSubscript,
   CustomSuperscript,
   InlineTable,
   InlineTableRow,
   InlineTableCell,
   InlineTableHeader,
   // Video,
   CustomTextAlign,
   VerticalAlign,
   CustomTextColor,
   CustomBackgroundColor,
   TableCellMenu,
} from './extensions';
import { Bold } from '@tiptap/extension-bold';
import { Strike } from '@tiptap/extension-strike';
import { Italic } from '@tiptap/extension-italic';
import { HardBreak } from '@tiptap/extension-hard-break';
import { CodeBlock } from '@tiptap/extension-code-block';
import { BulletList } from '@tiptap/extension-bullet-list';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { ListItem } from '@tiptap/extension-list-item';
import { Gapcursor } from '@tiptap/extension-gapcursor';

export type ExtensionProducer = (editorConfig: EditorConfig) => Extensions;

const wikitagToExtensionProducer: Partial<Record<Wikitag, ExtensionProducer>> = {
   Code: () => [CodeBlock],
   Delete: () => [Strike],
   Emphasis: () => [Italic],
   Heading: () => [CustomHeading],
   // Image: () => [MediaManager],
   Insert: () => [CustomUnderline],
   Linebreak: () => [HardBreak],
   Link: (editorConfig: EditorConfig) => [
      EditableLink.configure({ editorId: editorConfig.editorId }),
   ],
   List: () => [BulletList, OrderedList, ListItem],
   Mention: () => [CustomMention],
   // Postimage: () => [MediaManager],
   Quote: () => [CustomBlockquote],
   Strong: () => [Bold],
   Subscript: () => [CustomSubscript],
   Superscript: () => [CustomSuperscript],
   Teletype: () => [CustomCode],
   // Video: () => [Video],
   Inlinetable: () => [
      InlineTable,
      InlineTableRow,
      InlineTableCell,
      InlineTableHeader,
      Gapcursor,
      CustomTextAlign,
      VerticalAlign,
      CustomTextColor,
      CustomBackgroundColor,
      TableCellMenu,
   ],
};

const getExtensionProducerForWikitag = (wikitag: Wikitag): ExtensionProducer => {
   const extensionProducer = wikitagToExtensionProducer[wikitag];

   if (!extensionProducer) {
      return () => [];
   }

   return extensionProducer;
};

export const buildExtensionsFromWikitags = (editorConfig: EditorConfig): Extensions => {
   const extensions: Extensions = editorConfig.wikitags
      .filter((wikitag: Wikitag) => !editorConfig.exclude?.includes(wikitag))
      .map(getExtensionProducerForWikitag)
      .map((extensionProducer: ExtensionProducer) => extensionProducer(editorConfig))
      .flat();

   return extensions;
};
